export default () => ({
    sort: {}
});